import { FC } from "preact/compat";
import { NavLink, useLocation, useResolvedPath } from "react-router-dom";
import { TabItemProps } from "./interfaces";
import cn from "classnames";

const TabItem: FC<TabItemProps> = ({ item, id }) => {
    const location = useLocation();
    const path = useResolvedPath(item.link);
    const isActive = location.pathname === path.pathname;
    const { icon: Icon, link, name, disabled } = item;
    const Component = item.disabled ? "div" : NavLink;

    return (
        <Component
            to={link}
            title={
                disabled
                    ? `"${name}" is not available for you at the moment`
                    : undefined
            }
            data-floating-tab={`${id}-${name}`}
            className={cn(
                cn(
                    "px-4 py-2 capitalize flex gap-x-2 items-center h-full",
                    disabled
                        ? "text-gray-400 bg-gray-50"
                        : isActive
                          ? "text-white bg-header-mobile"
                          : "text-gray-500 hover:text-header-mobile",
                ),
            )}
        >
            <Icon width="20" height="20" className="fill-current" />
            <span>{name}</span>
        </Component>
    );
};

export default TabItem;
